import React from 'react';
import PropTypes from 'prop-types';

import {concatUrl} from '../helpers/url';
import {postCall} from '../helpers/request';
import GlobalContext from '../helpers/context';
import ActionButton from '../component/atoms/ActionButton';
import history from '../helpers/history';


class CurationProfileMergeButton extends React.Component {

    constructor(props) {
        super(props);

        this.merge_profile_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'merge');
        this.replace_curation_profile_url = concatUrl(window.ROOT_URL, 'api', 'curation_profile', 'replace');
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    onDialogCancel = (event) => {
        this.stopPropagation(event);
    };


    // +++ merge profile +++++++++++++++++++++++++++++++++++++++++++++++

    mergeProfileFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not merge the profile.');
    };

    mergeProfileDone = (data, callback_failure) => {
        if (data && data.error){
            switch(data.error) {
                case 'ProfileIdExistsError':
                    this.showProfileExistConfirmDialog(data);
                    break;
                case 'SameResourceInProfileError':
                    this.showSameSourcesConfirmDialog();
                    break;
                case 'MergeAllResourcesSharedError':
                    this.showAllResourcesSharedConfirmDialog();
                    break;
                case 'System':
                    this.setState({
                        confirm_dialog_is_open: false
                     });
                    callback_failure();
                    break;
            }
        }else{
            if(this.props.doneCallback){
                this.props.doneCallback(this.props.profile.profile_id);
            }
            this.context.displayGlobalInfo('Profile was successfully merged.');
        }
    };

    mergeProfile = (event) => {
        this.stopPropagation(event);
        const data = {
            curation_profile_id: this.props.curation_profile_id,
            merge_profile_id: this.props.profile.profile_id,
            workspace_id: this.props.workspace_id
        };
        postCall(this.merge_profile_url, data, this.mergeProfileDone, this.mergeProfileFailed);
    };

    showProfileExistConfirmDialog = (data) => {
        // Default - provide option to replace this CP
        let next_action = () => {this.replaceCurationProfile(data.curation_profile.id)};
        let confirm_dialog_text = `The profile ID ${data.profile_id} is already assigned to 
            the curation profile "${data.curation_profile.full_name}". Are you fine with 
            replacing this curation profile by the existing one because this curation 
            profile has no profile assigned yet?`;
        if(this.props.current_profile_id){
            // Provide force merge option
            next_action = this.forceMergeProfileProfileIdExists;
            confirm_dialog_text = `The profile ID ${data.profile_id} is already assigned to 
            the curation profile "${data.curation_profile.full_name}". Are you really sure 
            you want to take over the profile into this curation profile?`;
        }
        this.context.showConfirmationDialog({
            confirm_dialog_on_close: this.onDialogCancel,
            confirm_dialog_on_confirm: next_action,
            confirm_dialog_mode: 'warning',
            confirm_dialog_title: 'Attention!',
            confirm_dialog_text: confirm_dialog_text
        });
    };

    // +++ replace curation profile +++++++++++++++++++++++++++++++++++++++++++++++

    replaceCurationProfileFailed = () => {
        this.context.displayGlobalError('Backend service failure: Could not replace the curation profile.');
    };

    replaceCurationProfileDone = (data) => {
        history.push(`/workspaces/curation_profiles/details?id=${data.take_over_curation_profile_id}&workspace_id=${this.props.workspace_id}`);
    };

    replaceCurationProfile = (take_over_curation_profile_id) => {
        let data = {
            curation_profile_id: this.props.curation_profile_id,
            take_over_curation_profile_id: take_over_curation_profile_id,
            workspace_id: this.props.workspace_id
        };
        postCall(this.replace_curation_profile_url, data, this.replaceCurationProfileDone, this.replaceCurationProfileFailed);
    };


    forceMergeProfileProfileIdExists = () => {
        const data = {
            curation_profile_id: this.props.curation_profile_id,
            merge_profile_id: this.props.profile.profile_id,
            workspace_id: this.props.workspace_id,
            force_merge_profile_exist: true
        };
        postCall(this.merge_profile_url, data, this.mergeProfileDone, this.mergeProfileFailed);
    };

    showSameSourcesConfirmDialog = () => {
        this.context.showConfirmationDialog({
            confirm_dialog_on_close: this.onDialogCancel,
            confirm_dialog_on_confirm: this.forceMergeProfileSameResource,
            confirm_dialog_mode: 'warning',
            confirm_dialog_title: 'Attention!',
            confirm_dialog_text: `This profile has the same document in the list as the current 
            curation profile. Are you really sure you want to merge this profile?`
        });
    };

    forceMergeProfileSameResource = (event) => {
        this.stopPropagation(event);
        const data = {
            curation_profile_id: this.props.curation_profile_id,
            merge_profile_id: this.props.profile.profile_id,
            workspace_id: this.props.workspace_id,
            force_merge_same_sources: true
        };
        postCall(this.merge_profile_url, data, this.mergeProfileDone, this.mergeProfileFailed);
    };

    showAllResourcesSharedConfirmDialog = () => {
        this.context.showConfirmationDialog({
            confirm_dialog_on_close: this.onDialogCancel,
            confirm_dialog_on_confirm: null,
            confirm_dialog_mode: 'warning',
            confirm_dialog_title: 'Attention!',
            confirm_dialog_text: `This profile can't be merged because it has only resources already 
            in the current curation profile. Please ignore this profile.`
        });
    };

    showMergeConfirmationDialog = (event) => {
        this.stopPropagation(event);

        this.context.showConfirmationDialog({
            confirm_dialog_on_close: this.onDialogCancel,
            confirm_dialog_on_confirm: this.mergeProfile,
            confirm_dialog_mode: null,
            confirm_dialog_title: 'Please confirm',
            confirm_dialog_text: `Are you sure you want to merge the profile "${this.props.profile.full_name}" 
            (${this.props.profile.researcher_id}) into this curation profile?`,
            confirm_dialog_button_text: 'merge'
        });
    };

    render() {
        return (
            <GlobalContext.Consumer>{() => (
                <ActionButton
                    text="Merge"
                    linkStyle={true}
                    actionCallback={this.showMergeConfirmationDialog}
                />
            )}
            </GlobalContext.Consumer>
        );
    }
}

CurationProfileMergeButton.contextType = GlobalContext;

CurationProfileMergeButton.propTypes = {
    curation_profile_id: PropTypes.number.isRequired,
    current_profile_id: PropTypes.number.isRequired,
    workspace_id: PropTypes.number.isRequired,
    profile: PropTypes.object.isRequired,
    doneCallback: PropTypes.func
};

export default CurationProfileMergeButton;
